var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"report-type d-inline-block"},[_c('v-icon',{staticClass:"mr-1 pb-1",attrs:{"color":_vm.color,"size":"8"}},[_vm._v("mdi-circle")]),(_vm.withCategory)?[_vm._v(" "+_vm._s(_vm.getCategoryName)+" / ")]:_vm._e(),_vm._v(" "+_vm._s(_vm.$t(`reports.types.${_vm.report.type}.title`))+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }